import type { TView } from '@alfa-bank/site-text-v2/src/models';

import type { TSizes } from './models';

const SUFFIX = '₽';

const MINUS = 'Минус';
const PLUS = 'Плюс';

const selectors = {
    plus: 'btn-plus',
    minus: 'btn-minus',
};

export const configs = {
    SUFFIX,
    MINUS,
    PLUS,
    selectors,
};

export const VIEW: Record<TSizes, TView> = {
    1: 'xlarge',
    2: 'large',
    3: 'medium',
    4: 'small',
    5: 'xsmall',
};
